const originalInsertBefore = Node.prototype.insertBefore
const alreadyLoadedScripts = []

function isScript(node) {
    return node.tagName === 'SCRIPT' && node.src
}
function isAlreadyLoaded(node) {
    return alreadyLoadedScripts.indexOf(node.src) > -1
}

Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (!isScript(newNode)) {
        return originalInsertBefore.call(this, newNode, referenceNode)
    }

    if (isAlreadyLoaded(newNode)) {
        return
    }

    alreadyLoadedScripts.push(newNode.src)
    return originalInsertBefore.call(this, newNode, referenceNode)
}
